import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import Resume from './images/Vidhi_Sinha_Resume.pdf';

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="navbar">
      <Link to="/" className="brand" onClick={closeMenu}>Vidhi Sinha</Link>

      <nav className={`nav-links${menuOpen ? ' nav-open' : ''}`}>
        <a href="#featured-projects" onClick={closeMenu}>Work</a>
        <a href="#experience" onClick={closeMenu}>Experience</a>
        <a href="#skills" onClick={closeMenu}>Skills</a>
        <a href="#education" onClick={closeMenu}>Education</a>
        <a href="#contact" onClick={closeMenu}>Contact</a>
      </nav>

      <div className="nav-contact">
        <a href="mailto:27.vidhi@gmail.com" className="nav-text-link">Email</a>
        <a href="https://www.linkedin.com/in/vidhi-sinha-a65348b1/" target="_blank" rel="noopener noreferrer" className="nav-text-link">LinkedIn</a>
        <a href="https://github.com/VidhiSinha27" target="_blank" rel="noopener noreferrer" className="nav-text-link">GitHub</a>
        <a href={Resume} download="Vidhi_Sinha_Resume.pdf" className="resume-btn">Resume</a>
      </div>

      <button
        className={`hamburger${menuOpen ? ' open' : ''}`}
        onClick={() => setMenuOpen(v => !v)}
        aria-label="Toggle navigation"
      >
        <span /><span /><span />
      </button>
    </header>
  );
}
